const store = {
	namespaced: true,
	state: {
		meta: null,
	},
	mutations: {
		setMeta: (state, value) => state.meta = value,
	},
};

export default store;